import { render } from "./InAppPurchasePropsCmp.vue?vue&type=template&id=326a03c0"
import script from "./InAppPurchasePropsCmp.vue?vue&type=script&lang=js"
export * from "./InAppPurchasePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__